import React from 'react';
import marked from 'marked';

const ActivateVerified = ({ content }) =>
  content && content.content ? (
    <div
      className="ActivateVerified"
      dangerouslySetInnerHTML={{
        __html: marked(content.content),
      }}
    />
  ) : null;

export default ActivateVerified;
